/**
 * Keeps the Shop mega menu height in sync so hover open/close stays reliable.
 */
class BestiesShopMegaMenu extends HTMLElement {
  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    this.#resizeObserver = new ResizeObserver(this.#syncHeight);
    this.#resizeObserver.observe(this);

    const submenu = this.closest('.menu-list__submenu');
    submenu?.addEventListener('pointerenter', this.#syncHeight);
    this.addEventListener('load', this.#syncHeight, true);
    requestAnimationFrame(this.#syncHeight);
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    const submenu = this.closest('.menu-list__submenu');
    submenu?.removeEventListener('pointerenter', this.#syncHeight);
  }

  #syncHeight = () => {
    const submenu = this.closest('.menu-list__submenu');
    const headerMenu = this.closest('header-menu');
    const headerComponent = this.closest('header-component');

    if (!(submenu instanceof HTMLElement) || !(headerComponent instanceof HTMLElement)) return;

    const isOpen =
      submenu.dataset.active !== undefined ||
      submenu.matches(':hover') ||
      headerMenu?.querySelector('.menu-list__link--shop[aria-expanded="true"]');

    if (!isOpen) return;

    const submenuHeight = submenu.offsetHeight;
    if (submenuHeight <= 0) return;

    headerComponent.style.setProperty('--submenu-height', `${submenuHeight}px`);

    const isOverlapSituation = headerComponent.hasAttribute('data-submenu-overlap-bottom-row');
    const headerVisibleHeight =
      isOverlapSituation && headerComponent.offsetHeight > 0
        ? headerComponent.querySelector('.header__row--top')?.offsetHeight ?? 0
        : headerComponent.offsetHeight;

    headerComponent.style.setProperty(
      '--full-open-header-height',
      `${submenuHeight + headerVisibleHeight}px`
    );
  };
}

if (!customElements.get('besties-shop-mega-menu')) {
  customElements.define('besties-shop-mega-menu', BestiesShopMegaMenu);
}
